import { render, staticRenderFns } from "./statusMix.vue?vue&type=template&id=24935db8&scoped=true"
import script from "./statusMix.vue?vue&type=script&lang=js"
export * from "./statusMix.vue?vue&type=script&lang=js"
import style0 from "./statusMix.vue?vue&type=style&index=0&id=24935db8&prod&lang=scss&scoped=true"
import style1 from "./statusMix.vue?vue&type=style&index=1&id=24935db8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24935db8",
  null
  
)

export default component.exports